export default __webpack_public_path__ + "static/media/title_mob.4fb29da3.svg";